<div class="modal-dialog"
     id="new-request">
  <div class="modal-content p-0">
    <div class="modal-header">
      <button (click)="noAction()"
              class="close"
              data-dismiss="modal"
              type="button">
        <div class="dialog-close"></div>
      </button>
      <span>{{ 'Users' | translate }}</span>
    </div>
  </div>
</div>
<mat-dialog-content class="mat-typography py-0 ps-2">
  <app-frontend-filter (onFiltersChanged)="onFiltersChanged($event)"
                       [filters]="allFilters">
  </app-frontend-filter>
  <div class="card-table">
    <div class="card-body-table">
      <app-frontend-table [dataSource]="users"
                          [displayColumnEndpoints]="displayEndPoint"
                          [displayColumnTypes]="displayColumnTypes"
                          [displayColumns]="displayedColumns"
                          [displayDataSources]="displayDataSources"
                          [tableProperties]="tableProperties">
      </app-frontend-table>
    </div>
  </div>
</mat-dialog-content>
<div class="dialog-footer">
  <mat-dialog-actions align="end"
                      class="py-0">
    <div class="col-12 d-flex align-items-center justify-content-end footer"
         style="gap: 16px">
      <app-frontend-button (click)="noAction()"
                           [Image]="true"
                           [class]="'card-yellow'"
                           [disabled]="false"
                           [src]="'icons/close-square.svg'"
                           [title]="'Cancel'">
      </app-frontend-button>
    </div>
  </mat-dialog-actions>
</div>
